import { render } from "./IconDE.vue?vue&type=template&id=2c68f8d0"
const script = {}
script.render = render

export default script